import React from 'react';

const Loader = ({ propsClassName = "" }) => {
  return (
    <>
      <div className={`load-flx ${propsClassName}`}>
        <div id="loading"></div>
      </div>
      {/* Class Name: (load-smll -- for Small loader), (load-lag -- for large loader) */}
    </>
  );
};

export default Loader;